module.exports = {"key":"hello english","submit":"Send Feedback","hide":"Hide This","skip":"Skip To Next Question","placeholder":"Please describe how you feel about this"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 440
// module chunks = 0